<div *ngIf="showLoader">
    <div fxLayout="column" fxLayoutAlign="center center" *ngIf="isLoading | async" class="overlay">
        <div class="loader-box" fxLayout="column" fxLayoutAlign="center center">
            <div class="loader-logo">
                <img [src]="logoUrl" referrerpolicy="no-referrer" alt="Loading..." (error)="onLogoError($event)" />
            </div>
            <div class="loader"></div>
        </div>
    </div>
</div>